import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { ProductTypeActions, ProductTypeStore, STATUS } from 'Stores/productTypeStore'
import ProductTypeForm from 'Modules/productType/productTypeForm'

export default class ProductTypeEdit extends Component {
  constructor(props) {
    super(props)
    this.stores = [ProductTypeStore]
    this.storeKeys = ['status']
  }

  componentDidMount() {
    ProductTypeActions.getProductTypeDetails(this.props.match.params.ProductTypeID)
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('ProductType Updated', {
        autoClose: 3000,
        onClose: () => {
          ProductTypeActions.clearFormToast()
        }
      })
      ProductTypeActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('ProductType Update Failed', {
        autoClose: 3000,
        onClose: () => {
          ProductTypeActions.clearFormToast()
        }
      })
      ProductTypeActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <ProductTypeForm match={this.props.match} />
      </React.Fragment>
    )
  }
}
